import MisPagosForm from '../../../components/ui/Cliente/MisPagosComponents/FormMisPagos';

const MisPagosUI = () => {
  return (
    <div className=" bg-gray-100">
      <MisPagosForm />
    </div>
  );
};

export default MisPagosUI;